import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import SelectCountEvent from "./SelectCountEvent";

export const CountEventsList = () => {
  const allActiveCountsEvents = useSelector((state: RootState) => {
    return state.data.activeCountEvents;
  });


  return <Fragment>
  <SelectCountEvent countEventsList={allActiveCountsEvents} />
</Fragment>
}

